<script>
import SignaturePad from 'signature_pad'

export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    rules: { type: String, default: '' },
    label: { type: String, default: null },
  },
  data() {
    return {
      signature: '',
    }
  },
  mounted() {
    var vm = this
    this.pad = new SignaturePad(vm.$refs.signPad, {
      onEnd: vm.updateInput,
    })

    window.addEventListener('resize', vm.resizeCanvas);
    vm.resizeCanvas();
  },
  beforeDestroy() {
    this.pad.off()

    window.removeEventListener('resize', this.resizeCanvas)
  },
  methods: {
    clearPad() {
      this.pad.clear()
      this.$emit('update', '')
    },
    updateInput() {
      this.$emit('update', this.pad.toDataURL())
    },
   resizeCanvas() {
    const canvas = this.$refs.signPad
    const ratio = Math.max(window.devicePixelRatio || 1, 1)

    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext('2d').scale(ratio, ratio)

    this.pad.clear() // otherwise isEmpty() might return incorrect value
   }
  },
}
</script>

<template>
  <BaseValidationProvider
    v-slot="{ errors }"
    :rules="rules"
    :label="label"
    :label-for="$attrs.id"
  >
    <canvas
      ref="signPad"
      :class="['input h-48 w-full max-w-xs', errors.length ? 'input-error' : '']"
    ></canvas>
    <input v-bind="$attrs" class="hidden" v-on="$listeners" />
    <button class="btn bg-white border py-1 px-0 mt-2" @click="clearPad">
      Clear
    </button>
  </BaseValidationProvider>
</template>
